var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.92 23.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    "data-name": "Group 1222"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_382",
    "data-name": "Line 382",
    className: "cls-1",
    x1: 0.5,
    y1: 4.02,
    x2: 21.42,
    y2: 4.02
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    className: "cls-1",
    d: "M18.57,4.66l-.74,16.74c0,1.11-.91,2.02-2.02,2.02H6.49c-1.11,0-2.02-.91-2.02-2.02L3.47,4.66"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_383",
    "data-name": "Line 383",
    className: "cls-1",
    x1: 10.96,
    y1: 4.02,
    x2: 10.96,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_384",
    "data-name": "Line 384",
    className: "cls-1",
    x1: 8.49,
    y1: 20.22,
    x2: 8.49,
    y2: 8.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_385",
    "data-name": "Line 385",
    className: "cls-1",
    x1: 13.43,
    y1: 20.22,
    x2: 13.43,
    y2: 8.08
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBtn);
export default __webpack_public_path__ + "static/media/delete-btn.ac6accc8.svg";
export { ForwardRef as ReactComponent };